<template>
    <div>
        <header class="gh-header gh-mhss-header" id="gh-summit-header">
            <div class="gh-container">
                <nav class="gh-navigation" style="overflow: hidden">
                    <div class="gh-logos">
                        <a href="/" class="gh-logo-mha" target="_blank">
                            <img src="/images/app/MHA-Logo-2017[P].svg" alt="Mental Health Academy Logo" />
                        </a>
                       <a href="//www.bps.org.uk" target="_blank" class="gh-header__logo gh-header-logo-bps gh-header-logo-support">
                            <img src="/images/suicidePreventionSummit/logos/BPS_Logo_color.png" alt="BPS logo">
                        </a>
                    </div>
                    <ul v-show="!isSuccess" class="gh-menu">
                        <!-- <li class="ghNav-item">
                            <a class="js-smoothScroll gh-nav" @click="scrollToSection('partners')">Hosts</a>
                        </li> -->
                        <li class="ghNav-item">
                            <a class="js-smoothScroll gh-nav" @click="scrollToSection('speakers')">Speakers</a>
                        </li>
                        <li class="ghNav-item">
                            <a class="js-smoothScroll gh-nav" @click="scrollToSection('sessions')">Sessions</a>
                        </li>
                        <li class="ghNav-item">
                            <a class="js-smoothScroll gh-nav" @click="scrollToSection('ce-credits')">CPD Hours</a>
                        </li>
                        <li class="ghNav-item">
                            <a class="js-smoothScroll gh-nav" @click="scrollToSection('social-impact')">Impact</a>
                        </li>
                        <li class="ghNav-item">
                            <a class="js-smoothScroll gh-nav" @click="scrollToSection('faqs')">FAQs</a>
                        </li>
                        <li v-if="!hideRegister" class="ghNav-item gh-register">
                            <a class="js-smoothScroll" @click="scrollToSection('registration')">Register</a>
                        </li>
<!--                        <li v-if="!hideRegister" class="ghNav-item gh-portal-login">-->
<!--                            <a class="js-smoothScroll" :href="eventPortalLink(2022)" target="_blank">Portal Login</a>-->
<!--                        </li>-->
                    </ul>
                </nav>
                <gh-mobile-menu v-show="!isSuccess" class="gh-mobile-menu">
                    <gh-navigator slot="menu" />
                </gh-mobile-menu>
            </div>
        </header>
        <!-- End Header -->
    </div>
</template>

<script>
import ghMobileMenu from "@/modules/events/components/MobileMenu.vue";
import ghNavigator from "@/modules/events/suicidePreventionSummit/components/Navigator.vue";
import deviceMixin from "@/mixins/device";
import UX from "@/utils/ux";

export default {
    mixins: [deviceMixin],

    components: {
        ghMobileMenu,
        ghNavigator,
    },

    props: {
        isSuccess: {
            type: Boolean,
            default: false,
        },

        hideRegister: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            desktopPinScene: new ScrollMagic.Scene({ triggerHook: 0, reverse: true }),
        };
    },

    computed: {
        isRegistrationSuccess() {
            return this.$store.state.event.registrationSuccess;
        },
    },

    methods: {
        scrollToRegistrationForm() {
            UX.scrollTo(document.getElementById("js-registration"), 1, 70);
        },

        scrollToSection(section) {
            const element = document.getElementById(section);

            element && UX.scrollTo(element, 1, 70);

            this.$emit("clicked");
        },

        popUpMsg() {
            this.$alert(
                "The Event Portal for the 2022 Suicide Prevention Summit will be accessible for registered attendees from Monday, April 18. Keep an eye on your emails for further instructions.",
                "Hold tight... we'll be ready soon",
                {
                    confirmButtonText: "OK",
                }
            );
        },

        eventPortalLink(year) {
            return `https://events.mentalhealthacademy.net/suicideprevention/${year}/verify`;
        }
    },
};
</script>

<style lang="scss" scoped>
.gh-navigation {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.gh-mobile-menu {
    display: none;
    float: right;
    position: absolute;
    top: 15px;
    right: 3%;
}

.top-sticky {
    .gh-header {
        background-color: white;
    }
}

a {
    cursor: pointer;
}

.gh-logos {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;

    .gh-header-logo-support {
        display: none;
    }

    .gh-logo-hint {
        display: block;
        font-style: italic;
        font-size: 1.2rem;
        font-weight: 700;
        margin-right: 1rem;
        padding-top: 0.3rem;
    }

    .gh-logo-mha {
        max-width: 175px;
        margin-left: 0;
    }

    a {
        // margin-top: 5px;
        padding-right: 10px;
        margin-left: 10px;
    }

    .gh-logo-act {
        // max-width: 200px;

        +.gh-logo-act {
            margin-left: 1rem;
        }
    }

    .gh-logo-nbcc img {
        width: 190px;
        height: auto;
    }
}

.gh-nav {
    font-weight: 600;
    transition: 0.3s;
    color: #474f59;
    font-size: 1.2rem;

    &:hover {
        color: #9197a5 !important;
    }
}

.gh-header {
    padding: 15px 0;
    border-bottom: none;
    background-color: rgba(255, 255, 255, 0.7);
    box-shadow: 0px 4px 18px 0px rgba(226, 224, 224, 63%);

    .gh-container {
        max-width: 1373px;
        padding: 0 2rem;
        margin: auto;
    }
}

.ghNav-item {
    display: inline-block;
    padding: 0 1rem;
    a {
        font-family: Catamaran, sans-serif;
    }
}

.gh-register {
    margin-left: 1rem;
    transition: 0.3s;
    color: white;
    background-color: #f76c6c;
    padding: 5px 29.5px;
    border-radius: 3px;

    a {
        color: white;
        font-size: 1.2rem;
    }

    &:hover {
        background-color: #ffaa98 !important;
    }
}

.gh-portal-login {
    margin-left: 1rem;
    transition: 0.3s;
    color: white;
    background-color: #514a9d;
    padding: 5px 20px;
    border-radius: 3px;

    a {
        color: white;
        font-size: 1.2rem;
    }

    &:hover {
        background-color: #48428c !important;
    }
}

.gh-menu {
    display: block;
}

.gh-logos .gh-header__logo {
    width: 122px;
    float: left;
}

.gh-logos .gh-header__logo + .gh-header__logo {
    margin-left: 0.5rem;
}

@media screen and (max-width: 1300px) {
    .gh-menu {
        display: none;
    }

    .gh-mobile-menu {
        display: block;
    }
}

@media screen and (max-width: 767px) {
    .gh-logos {
        .gh-logo-act {
            display: none;
        }
    }
}

@media (min-width: 480px) {
    .gh-logos .gh-header-logo-support {
        display: block;
    }
}

@media (min-width: 768px) {
    .gh-logos .gh-header__logo {
        margin-right: 8px;
        width: 170px;
    }
}

@media screen and (min-width: 1024px) {
    .gh-header__logo {
        -ms-flex-positive: 1;
        flex-grow: 1;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        max-width: 150px;
    }
}

@media screen and (min-width: 1280px) {
    .gh-header__logo {
        max-width: 170px;
    }
}

</style>
<style lang="scss">
.gh-page-summit {
    .s-navigator {
        display: block !important;
    }
}
</style>
